import Vue from 'vue';
import Vuex from 'vuex';
// import createPersistedState from 'vuex-persistedstate';
Vue.use(Vuex);

import Account from './modules/account';
import event from './modules/events'
import stores from './modules/stores'
import request from "./modules/request";
import property from "./modules/property";
import contact from "./modules/contact";
import advertisement from "./modules/advertisement";
import uConnect from "./modules/uConnect";
import stripe from "./modules/stripe"
import enquiry from "./modules/enquiry";
import faq from "./modules/faq";

const state = {
};

const getters = {
};

const mutations = {};

const actions = {};

const store = new Vuex.Store({
  state,
  getters,
  mutations,
  actions,
  modules: {
    Account,
    event,
    stores,
    request,
    property,
    contact,
    advertisement,
    uConnect,
    stripe,
    enquiry,
    faq
  },
  // plugins: [
  //   createPersistedState({
  //     paths: ['property']
  //   }),
  // ],
  strict: true
});

export default store;



// WEBPACK FOOTER //
// ./src/store/index.js